module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "inter"
  }, [(_vm.billedByPartner || _vm.uiSettings[_vm.hideDeductibleCreditArea] !== true) ? _c('div', {
    staticClass: "mv2"
  }, [_c('div', {
    staticClass: "cell-multiple ph3 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "flex justify-between items-center responsive-text"
  }, [_c('span', {
    staticClass: "mb1 silver-element"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.deductible', {
    deductible: 'Total Deductible Credit Balance'
  })))]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.user.total_deductible_credit.toFixed(2)))])])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "line mv3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [_c('div', {
    staticClass: "flex ph3 justify-between"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.yourplan', {
    yourplan: 'Your Plan'
  })))])]), _vm._v(" "), (_vm.hasContract) ? _c('div', [_c('contract-line-items', {
    staticClass: "mv3",
    attrs: {
      "contract-line-items": _vm.contractLineItemsByCategory(_vm.userContract.line_items, 'COVERAGE'),
      "is-billed-by-partner": _vm.billedByPartner,
      "discount": _vm.discount,
      "phone": _vm.user.phone_no
    },
    scopedSlots: _vm._u([{
      key: "changePlan",
      fn: function() {
        return [(_vm.uiSettings[_vm.hideChangePlan] !== true) ? _c('router-link', {
          staticClass: "no-underline dib-ns",
          attrs: {
            "to": "/edit-coverage"
          }
        }, [_c('span', {
          staticClass: "color-theme"
        }, [_vm._v(_vm._s(_vm.$t('planssettings.changeplan', {
          changeplan: 'Change plan'
        })))])]) : _vm._e()]
      },
      proxy: true
    }], null, false, 1690854759)
  }), _vm._v(" "), (_vm.contractLineItemsByCategory(_vm.userContract.line_items, 'UPSELL').length) ? _c('div', {
    staticClass: "mt2"
  }, [_c('span', {
    staticClass: "ph3 silver-element mb3"
  }, [_vm._v("Add-On Plan(s)")]), _vm._v(" "), _c('contract-line-items', {
    staticClass: "mv3",
    attrs: {
      "contract-line-items": _vm.contractLineItemsByCategory(_vm.userContract.line_items, 'UPSELL'),
      "is-billed-by-partner": _vm.billedByPartner,
      "discount": _vm.discount,
      "phone": _vm.user.phone_no
    }
  })], 1) : _vm._e()], 1) : _c('div', [(!_vm.billedByPartner) ? _c('div', {
    staticClass: "cell-multiple ph3 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "flex justify-between items-center responsive-text"
  }, [_c('span', {
    staticClass: "mb1"
  }, [_vm._v(_vm._s(_vm.coveragePlanFirstLine))]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.discount_amount))])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.coveragePayPeriodFirstLine) + " • " + _vm._s(_vm.$t('login.phone', {
    phone: 'Phone'
  })) + ": " + _vm._s(_vm.user.phone_no))]), _vm._v(" "), (_vm.uiSettings[_vm.hideChangePlan] !== true) ? _c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/edit-coverage"
    }
  }, [_c('span', {
    staticClass: "color-theme"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.changeplan', {
    changeplan: 'Change plan'
  })))])]) : _vm._e()], 1)]) : _c('div', {
    staticClass: "cell-multiple ph3 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "flex justify-between items-center responsive-text"
  }, [_c('span', {
    staticClass: "mb1"
  }, [_vm._v(_vm._s(_vm.coveragePlanFirstLine))])])])])]), _vm._v(" "), (this.user.related_users && this.user.related_users.length > 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.billedByPartner),
      expression: "!billedByPartner"
    }],
    staticClass: "mv3"
  }, [_c('hr', {
    staticClass: "line mb3"
  }), _vm._v(" "), _c('div', {
    staticClass: "ph3 flex justify-between items-center"
  }, [_c('span', {
    staticClass: "silver-element mb2"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.otherplans', {
    otherplans: 'Other Plans'
  })))])]), _vm._v(" "), (_vm.hasSecondaryUserContracts) ? _c('div', _vm._l((_vm.secondaryContracts), function(contract, index) {
    return _c('div', {
      key: index
    }, [_c('contract-line-items', {
      staticClass: "mv3",
      attrs: {
        "contract-line-items": _vm.contractLineItemsByCategory(contract.line_items, 'COVERAGE'),
        "is-billed-by-partner": _vm.billedByPartner,
        "discount": _vm.discount,
        "phone": contract.user.phone
      }
    }), _vm._v(" "), _c('contract-line-items', {
      staticClass: "mv3",
      attrs: {
        "contract-line-items": _vm.contractLineItemsByCategory(contract.line_items, 'UPSELL'),
        "is-billed-by-partner": _vm.billedByPartner,
        "discount": _vm.discount,
        "phone": contract.user.phone
      }
    })], 1)
  }), 0) : _c('div', _vm._l((_vm.otherPlans), function(ref, index) {
    var user = ref.user;
    var plan = ref.plan;
    var planType = ref.planType;
    var discountAmount = ref.discountAmount;
    var phone = ref.phone;
    var itemCovered = ref.itemCovered;

    return _c('div', {
      key: index,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "3 flex justify-between items-center cell-multiple responsive-text"
    }, [_c('div', {
      staticClass: "flex ph3 flex-column"
    }, [_c('span', {
      staticClass: "mb1"
    }, [_vm._v(_vm._s(plan))]), _vm._v(" "), _c('span', {
      staticClass: "silver-element"
    }, [_vm._v(_vm._s(planType) + " • " + _vm._s(_vm.$t('login.phone', {
      phone: 'Phone'
    })) + ": " + _vm._s(phone))])]), _vm._v(" "), _c('div', {
      staticClass: "ph3 flex items-end flex-column"
    }, [_c('span', [_vm._v("$" + _vm._s(discountAmount))])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.billedByPartner),
      expression: "!billedByPartner"
    }],
    staticClass: "mt4 ph3"
  }, [(_vm.uiSettings[_vm.hideAddPlan] !== true) ? _c('router-link', {
    staticClass: "no-underline dib-ns responsive-width",
    attrs: {
      "to": "/add-plan"
    }
  }, [_c('ak-button', {
    staticClass: "height-diff inter",
    attrs: {
      "disabled": !this.user.is_activated,
      "primary": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('planssettings.addplan', {
    addplan: 'Add Plan'
  })))])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b5af55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/plans/PlansComponent.vue
// module id = 1146
// module chunks = 0